import { NgModule } from '@angular/core'

import { VendorModule } from '@shared/vendor.module'
import { WidgetsModule } from '@shared/widgets/widgets.module'
import { FormModule } from '../form/form.module'
import { DirectiveModule } from '@shared/directives/directive.module'

import { BillingTableComponent } from './billing-table/billing-table.component'
import { BillingTableRowComponent } from './billing-table-row/billing-table-row.component'
import { BillingTableRowExpandedComponent } from './billing-table-row-expanded/billing-table-row-expanded.component'
import { BillingCardComponent } from './billing-card/billing-card.component'
import { SubscriptionBreakdownTableComponent } from './subscription-breakdown-table/subscription-breakdown-table.component'
import { PipesModule } from '@shared/pipes/pipes.module'

@NgModule({
  declarations: [
    BillingTableComponent,
    BillingTableRowComponent,
    BillingTableRowExpandedComponent,
    BillingCardComponent,
    SubscriptionBreakdownTableComponent,
  ],
  imports: [VendorModule, WidgetsModule, FormModule, DirectiveModule, PipesModule],
  exports: [
    BillingTableComponent,
    BillingTableRowComponent,
    BillingTableRowExpandedComponent,
    BillingCardComponent,
    SubscriptionBreakdownTableComponent,
  ],
})
export class BillingSharedModule {}
